export function listUser(params) {
    return window.axios.post("api/user/list", params)
}
export function myUserList(params) {
    return window.axios.post("api/user/myUserList", params)
}

export function deleteUser(id) {
    return window.axios.post("api/user/delete", { id: id })
}
export function batchDeleteUser(id) {
    return window.axios.post("api/user/batchDelete", { ids: id })
}

export function updateUser(params) {
    return window.axios.post("api/user/update", params)
}

export function addUser(params) {
    return window.axios.post("api/user/add", params)
}

export function getUser(id) {
    return window.axios.post("api/user/get", { id: id })
}

export function exportUser(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/user/export/excel", params, config)
}

export function updateInfo(params) {
    return window.axios.post("api/user/updateInfo", params)
}
export function updateInfoverify(params) {
    return window.axios.post("api/user/updateInfoverify", params)
}

export function updatePassword(params) {
    return window.axios.post("api/user/updatePassword", params)
}
export function exportUserConfig() {
    return window.axios.post("api/user/exportConfig", {})
}
